<template>
  <a-layout class='index animated fadeIn p-b-20'>
    <div class='s_flex_around_c m-t-10'>
      <a-card hoverable style="width: 30%;background-color:#FBFCFC;border-radius:20px;" :bordered='false' v-has:productList="()=>link('/product/libs/management/index')">
          <img alt="example" src="@/assets/images/product/chanpin@2x.png" class='width-40 marigin_lr_auto p-t-10 ' />
          <h6 class='text-ac m-b-10 s_c8e m-t-8'>已上传产品</h6>
          <h6 class='text-ac fz-30'>{{result.already_product_total}}</h6>
      </a-card>
      <a-card hoverable style="width: 30%;background-color:#FBFCFC;border-radius:20px;" :bordered='false' v-has:productList="()=>link('/product/libs/management/index')">
          <img alt="example" src="@/assets/images/product/fenlei@2x.png" class='width-40 marigin_lr_auto p-t-10' />
        <h6 class='text-ac m-b-10 s_c8e m-t-8'>未分类产品</h6>
        <h6 class='text-ac fz-30'>{{result.no_category_product_total}}</h6>
      </a-card>
      <a-card hoverable style="width: 30%;background-color:#FBFCFC;border-radius:20px;" :bordered='false' v-has:giftList="()=>link('/product/gift/gift/management/index')">
          <img alt="example" src="@/assets/images/product/lipinku_ic_gift@2x.png" class='width-40 marigin_lr_auto p-t-10'  />
        <h6 class='text-ac m-b-10 s_c8e m-t-8'>已上传礼品</h6>
        <h6 class='text-ac fz-30'>{{result.already_gift_total}}</h6>
      </a-card>
    </div>
    <div class='m-t-8 s_flex_around_c'>
      <SmallSquare content="产品库管理进阶" color="#fff" />
      <a-button type="primary" class='m-r-50' v-has:createProduct="()=>{$router.push('/product/libs/management/createProduct')}">
        <PlusOutlined />上传产品
      </a-button>
    </div>
    <ul class="tips">
        <li>
          <img src="@/assets/images/product/product_index_icon3.png" alt="" >
          <div>
            <h6>什么是产品库?</h6>
            <p>产品库是系统内通用的产品管理仓库,可用于各个业务板块的关联调用,也可上架到云店商城进行线上销售,彻底删除后关联调用的产品也会失效</p>
          </div>
        </li>
        <li>
          <img src="@/assets/images/product/product_index_icon4.png" alt="" >
          <div>
            <h6>产品命名规范?</h6>
            <p>产品命名由品牌名称+商品名称组成，品牌名称可选择性显示，商品名称不能超过50字，且不得带有任何与商品真实信息无关的文字或符号</p>
          </div>
        </li>
        <li>
          <img src="@/assets/images/product/product_index_icon2.png" alt="" >
          <div>
            <h6>如何合理应用产品分类?</h6>
            <p>产品分类是一种通过给产品分组来管理产品的方式。当商品种类繁多或者系统分类无法满足需求时，可以按照不同标准给商品进行自定义分类</p>
          </div>
        </li>
        <li>
          <img src="@/assets/images/product/product_index_icon1.png" alt="" >
          <div>
            <h6>礼品的作用?</h6>
            <p>商家可以统一上传和管理礼品，礼品主要用于云店商城促销赠品，积分商城兑换礼品，或营销抽奖扫码活动等的奖品，不能直接上架到云店商城销售</p>
          </div>
        </li>
    </ul>
    <!-- <img class="width93 marigin_lr_auto   " src="" alt=""> -->
  </a-layout>
</template>
<script>
import {PlusOutlined } from '@ant-design/icons-vue';
import { getProductGeneral } from "@/api/product";
import { inject, ref } from 'vue';
export default {
  components:{
    PlusOutlined
  },
  setup(){
    const result=ref({})
    const initData=async()=>{
      let res =await getProductGeneral().then(res=>res.data)
      result.value=res.data
    }
    initData()
    const $router=inject('$router')
    const link=(url)=>{
      $router.push(url)
    }
    return{
      result,
      link
    }
  }

}
</script>
<style lang="less" scoped>
.index {
  background-color: #fff;
}
.ant-card-body {
  display: none;
}
.example{
  width: ~`vw(75)`;
}
.tips{
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
  justify-content: space-between;
  li{
    width: 49%;
    display: flex;
    border: 1px solid rgb(34, 75, 120);
    border-radius: 8px;
    margin-bottom: 20px;
    align-items: center;
    padding: 15px;
    font-size: 14px;
    color: #999;
    h6{
      font-weight: 600;
      margin-bottom: 5px;
      font-size: 16px;
    }
    img{
      width: 100px;
      margin-right: 20px;
    }
  }
}
</style>